/**
 * Get facet links based on a category. Returns the list of links.
 */
import Link from '~/jobiqo/components/Link';

export const getFacetLinks = (
  category,
  LinkWrapper = ({ children }) => <>{children}</>,
) =>
  category?.facet?.values?.map((facet) => (
    <LinkWrapper key={facet?.filter}>
      <Link
        data-test-id={`facet-link-${category?.facet?.name}`}
        href={`/jobs/${facet?.alias}`}
        prefetch={false}
      >
        {`${facet?.label} (${facet?.totalCount})`}
      </Link>
    </LinkWrapper>
  ));
